

const S4 = function() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  export function guid() {
    return (S4() + S4() +'-' +S4() +'-' +S4() +'-' +S4() +'-' +S4() +S4() +S4()
    );
  }


  export function rTime(date) {
    var json_date = new Date(date).toJSON();
    return new Date(new Date(json_date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
    }

  /*
 * d  日期字符串
 * type  D返回日期  T返回时间
 */
export function dateTextFormat(d, type) {
  var dateTime = "";
  if (d != null) {
      if (d.length >= 8) {
          dateTime = d.substring(0, 4) + "-" + d.substring(4, 6) + "-" + d.substring(6, 8);
          if (type == 'D') {
              return dateTime;
          }
      }
      if (d.length == 14) {
          var time = d.substring(8, 10) + ":" + d.substring(10, 12) + ":" + d.substring(12, 14);
          dateTime += " " + time;
          if (type == 'T') {
              return time;
          }

      }
  }
  return dateTime;
}
  /**
 * @date:日期时间戳    获取当前时间戳  Date.parse(new Date())
 * @format:需要转换的格式：yyyy-MM-dd   yyyy-MM-dd hh:mm:ss
 */
export function dateFormat(date, format) {
  if (typeof date == "string") {
      return formatDate(new Date(parseInt(date)), format);
  } else {
      return formatDate(new Date(date), format);
  }
}
function formatDate(date, format='yyyy-MM-dd') {
  var v = "";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  var weekDay = date.getDay();
  var ms = date.getMilliseconds();
  var weekDayString = "";
  if (weekDay == 1) {
    weekDayString = "星期一";
  } else if (weekDay == 2) {
    weekDayString = "星期二";
  } else if (weekDay == 3) {
    weekDayString = "星期三";
  } else if (weekDay == 4) {
    weekDayString = "星期四";
  } else if (weekDay == 5) {
    weekDayString = "星期五";
  } else if (weekDay == 6) {
    weekDayString = "星期六";
  } else if (weekDay == 7) {
    weekDayString = "星期日";
  }
  v = format;
  //Year
  v = v.replace(/yyyy/g, year);
  v = v.replace(/YYYY/g, year);
  v = v.replace(/yy/g, (year + "").substring(2, 4));
  v = v.replace(/YY/g, (year + "").substring(2, 4));
  //Month
  var monthStr = ("0" + month);
  v = v.replace(/MM/g, monthStr.substring(monthStr.length - 2));
  //Day
  var dayStr = ("0" + day);
  v = v.replace(/dd/g, dayStr.substring(dayStr.length - 2));
  //hour
  var hourStr = ("0" + hour);
  v = v.replace(/HH/g, hourStr.substring(hourStr.length - 2));
  v = v.replace(/hh/g, hourStr.substring(hourStr.length - 2));
  //minute
  var minuteStr = ("0" + minute);
  v = v.replace(/mm/g, minuteStr.substring(minuteStr.length - 2));
  //Millisecond
  v = v.replace(/sss/g, ms);
  v = v.replace(/SSS/g, ms);
  //second
  var secondStr = ("0" + second);
  v = v.replace(/ss/g, secondStr.substring(secondStr.length - 2));
  v = v.replace(/SS/g, secondStr.substring(secondStr.length - 2));
  //weekDay
  v = v.replace(/E/g, weekDayString);
  return v;
}



//生日转换岁数
export function getAge(birthday) {
  let birthdays = new Date(birthday.replace(/-/g, "/"));
  let d = new Date();
  let age =
      d.getFullYear() -
      birthdays.getFullYear() -
      (d.getMonth() < birthdays.getMonth() ||
      (d.getMonth() == birthdays.getMonth() &&
          d.getDate() < birthdays.getDate())
          ? 1
          : 0);
  return age;
}

export function isIdCardNo(id) 
{
     // 1 "验证通过!", 0 //校验不通过 // id为身份证号码
    var format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
    //号码规则校验
    if (!format.test(id)) {
    return false;
    }
    //区位码校验
    //出生年月日校验  前正则限制起始年份为1900;
    var year = id.substr(6, 4),
    //身份证年
    month = id.substr(10, 2),
    //身份证月
    date = id.substr(12, 2),
    //身份证日
    time = Date.parse(month + '-' + date + '-' + year),
    //身份证日期时间戳date
    now_time = Date.parse(new Date()),
    //当前时间戳
    dates = (new Date(year, month, 0)).getDate(); //身份证当月天数
    if (time > now_time || date > dates) {
    return false;
    }
    //校验码判断
    var c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //系数
    var b = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'); //校验码对照表
    var id_array = id.split("");
    var sum = 0;
    for (var k = 0; k < 17; k++) {
        sum += parseInt(id_array[k]) * parseInt(c[k]);
    }
    if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
        return false;
    }
    return true;
}

